export function isName(name) {
  if (!name) return false;
  return new RegExp(/^[a-zA-Z]+(([',. -][a-zA-Z ])?[a-zA-Z]*)*$/g).test(name);
}

export function isMobileNumber(mobile) {
  if (!mobile) return false;
  return new RegExp(/^[0][6-9]\d{9}$|^[6-9]\d{9}$/g).test(mobile);
}

export function isPinCodeNumber(pincode) {
  if (!pincode) return false;
  return new RegExp(/^(\d{4}|\d{6})$/g).test(pincode);
}

export function isAadhaarCardNumber(aadhar) {
  if (!aadhar) return false;
  return new RegExp(/^\d{12}$/g).test(aadhar);
}

export function isPanCardNumber(pan) {
  if (!pan) return false;
  return new RegExp(/^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$/g).test(pan);
}

export function isGstNumber(gst) {
  if (!gst) return false;
  return new RegExp(
    /^([0]{1}[1-9]{1}|[1-2]{1}[0-9]{1}|[3]{1}[0-7]{1})([a-zA-Z]{5}[0-9]{4}[a-zA-Z]{1}[1-9a-zA-Z]{1}[zZ]{1}[0-9a-zA-Z]{1})+$/g
  ).test(gst);
}

export function isBankAccountNumber(bankAcc) {
  if (!bankAcc) return false;
  return new RegExp(/^[0-9]{7,14}$/g).test(bankAcc);
}

export function isIfscCode(ifsc) {
  if (!ifsc) return false;
  return new RegExp(/^[A-Za-z]{4}0[A-Z0-9a-z]{6}$/g).test(ifsc);
}

export function isEmail(email) {
  if (!email) return false;
  return new RegExp(
    /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/g
  ).test(email);
}

export function isUpiCode(upi) {
  if (!upi) return false;
  return new RegExp(/^\w+@\w+$/g).test(upi);
}

export function isAlphaNumeric(_text) {
  if (!_text) return false;
  return new RegExp(/^[A-Za-z0-9_, -]*$/g).test(_text);
}

export function isNumber(_number) {
  if (!_number) return false;
  return new RegExp(/^[0-9]*$/g).test(_number);
}
